// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1ZWRp","error":"Textarea_error__37umX","readonly":"Textarea_readonly__1MnRb","disabled":"Textarea_disabled__3lYTq"};